import env from '@/config/env';
export var mutations = {
    setLoadingJobList: function (state, loading) {
        state.loadingJobList = loading;
    },
    setLoadingLandingPages: function (state, loading) {
        state.loadingLandingPages = loading;
    },
    setJobList: function (state, jobList) {
        state.jobList = jobList;
    },
    setPages: function (state, pages) {
        state.landingPages = pages;
    },
    setLandingPagePagination: function (state, pagination) {
        state.landingPagePagination = pagination;
    },
    setJobListNotFound: function (state, found) {
        state.jobListNotFound = found;
    },
    setLocations: function (state, payload) { return state.locations = payload; },
    setPrivacyPolicyUrl: function (state, url) {
        var _a, _b;
        if (url === null || url === 'https://privacy.jobilla.com/') {
            url = env.APPS.PRIVACY.CANDIDATE_URL((_a = state.jobList) === null || _a === void 0 ? void 0 : _a.locale, (_b = state.landingPages[0]) === null || _b === void 0 ? void 0 : _b.companyId);
        }
        state.privacyPolicyUrl = url;
    },
};
export var types = {
    SET_LOADING_JOB_LIST: 'setLoadingJobList',
    SET_LOADING_LANDING_PAGES: 'setLoadingLandingPages',
    SET_JOB_LIST: 'setJobList',
    SET_PAGES: 'setPages',
    SET_LANDING_PAGE_PAGINATION: 'setLandingPagePagination',
    SET_JOB_LIST_NOT_FOUND: 'setJobListNotFound',
    SET_LOCATIONS: 'setLocations',
    SET_PRIVACY_POLICY_URL: 'setPrivacyPolicyUrl',
};
